import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import Card from '../../components/Card';
import Sidebar from '../../components/sidebar/sidebar';
import AboutDefatom from './AboutDefatom';
import GuidePage from './GuidePage';

const GuideDefatom = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState<'About' | 'Guide' | 'Support'>('Guide');
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#000000)] flex-1">
        <Header title="Support" dropdown={2} />
        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <div className="flex items-center justify-between mb-4">
            {/* Title */}
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              {['About', 'Guide', 'Support'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => {
                    setActiveTab(tab as 'About' | 'Guide' | 'Support');
                    if (tab === 'About') {
                      navigate('/GuideAndSupport');
                    }
                    if (tab === 'Support') {
                      navigate('/GuideAndSupport/Support');
                    }
                  }}
                  style={{
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    borderRight: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                    borderLeft: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                    color: '#fff',
                    cursor: 'pointer',
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
          <GuidePage />
        </Card>
      </div>
    </div>
  );
};

export default GuideDefatom;
